import { Component, Input } from '@angular/core';
import { map, switchMap, tap } from 'rxjs';
import { StudentShoppingCartService } from 'src/app/col/services/student-shopping-cart.service';
import { LangProductMapper } from 'src/app/col/utils/lang-mappers';
import { SpinnerService } from 'src/app/utils/services/spinner.service';
import { NativeServiceApiProvider } from '../../../../../services/native-api-provider.service';
import * as LessonsV3 from '../../../../model/v3/lessons';
import { Page, Pageable } from '../../../../../utils/pageable';

@Component({
  selector: 'app-starter-product-card',
  templateUrl: './starter-product-card.component.html',
  styleUrls: ['./starter-product-card.component.scss'],
  standalone: false,
})
export class StarterProductCardComponent {
  @Input()
  set currency(value: string) {
    this._currency = value;
    this.loadStarterProduct();
  }
  get currency() {
    return this._currency;
  }

  @Input()
  set language(value: string) {
    this._language = value === 'sp' ? 'sp' : 'en';
    this.loadStarterProduct();
  }
  get language() {
    return this._language;
  }

  private _currency: string;
  private _language: string;

  starterProduct: LessonsV3.ProductVariantPreview | null = null;

  constructor(
    private apiProvider: NativeServiceApiProvider,
    private shoppingCart: StudentShoppingCartService,
    private spinner: SpinnerService
  ) {}

  getLangName() {
    return LangProductMapper.mapLangCodeToLangName(this.language || 'en');
  }

  getPricePerLesson(): string {
    if (!this.starterProduct) return '';
    const price = this.starterProduct.price?.value ?? 0;
    const currency = this.starterProduct.price?.currency ?? this._currency;
    const perLesson = price / 3;
    return `${perLesson.toFixed(2)} ${currency}`;
  }

  addStarterToCart(): void {
    if (!this.starterProduct) return;
    this.shoppingCart.addItem(this.starterProduct);
  }

  private loadStarterProduct(): void {
    if (!this._currency || !this._language) return;
    const label = `category:lessons.${this._language}.starter`;
    this.spinner
      .trace<LessonsV3.ProductVariantPreview[]>(
        this.apiProvider
          .colV3()
          .pipe(
            switchMap((api) =>
              api.getProductVariants(
                'preview',
                'lessons',
                null,
                this._language,
                this._currency,
                null,
                new Pageable(0, 500, null)
              )
            ),
            map((page: Page<LessonsV3.ProductVariantPreview>) => page?.content ?? [])
          )
          .pipe(
            tap((products) => {
              this.starterProduct =
                products.find((product) =>
                  product.labels?.includes(label)
                ) || null;
            })
          )
      )
      .subscribe();
  }
}
